import { environmentBase } from './config';

export const environment = {
  ...environmentBase,
  apiUrl: '/pq-test',
  dealerTypeId: 2,
  userInactivityMinutes: 15,
  userInactivityResponseSeconds: 30,
  okta: {
    domain: 'autht.securebanklogin.com',
    clientId: '0oa107ogfnqruaO8A1d8',
    redirectUri: 'https://zimmaticquote.dfsfintest.com/login/callback',
    scopes: ['openid', 'profile', 'email', 'offline_access'],
  },
};
